import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FirmContextService } from '../services/firm-context.service';
import { shouldAttachFirmHeader } from '../logic/firm-header-scope';

export const firmContextInterceptor: HttpInterceptorFn = (req, next) => {
  const firmContext = inject(FirmContextService);
  const firmId = firmContext.activeFirmId;

  if (!firmId) return next(req);

  // Stamp X-Firm-Id on our firm-workspace backend AND the case-management
  // backend (different origin). Other cross-origin services are excluded.
  if (!shouldAttachFirmHeader(req.url, [environment.baseUrl, environment.caseMgmtUrl])) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { 'X-Firm-Id': firmId } }));
};
